module.exports = __webpack_public_path__ + "media/images/admin/icons/award-1ca6c258ab69c5aa417a7f3f04f29e65.svg";